import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid , Image , Checkbox , Icon } from 'semantic-ui-react';
import DPayConcept from './dPay/concept';
import DPayTopUp from './dPay/topup';
import DPayRedeem from './dPay/redeem';
import DPayTopUpRule from './dPay/topUpRule';
import DPayApp from './dPay/dPayApp';

const styles = {
	container : {
		backgroundColor : 'white' , 
		height : 'auto' , 
		margin : 0
	}
}

class DPayFunction extends Component {
	render(){
		return (
			<Grid stackable style={styles.container}>
				<DPayConcept/>
				<DPayTopUp/>
				<DPayRedeem/>
				<DPayTopUpRule/>
				<DPayApp/>
			</Grid>
		)
	}
}

function mapStateToProps(state) {
  return {
    string : state.preference.string
  }
}

export default connect(mapStateToProps,null)(DPayFunction)



/** WEBPACK FOOTER **
 ** ./src/containers/features/dPayFunction.js
 **/